import { currencySymbols } from './currencySymbols.js';

export function formatPrice(price, preferredCurrency = 'USD', exchangeData) {
  if (price === null || price === undefined || Number.isNaN(Number(price))) {
    return '';
  }

  const numericPrice = Number(price);

  // Get symbol for the preferred currency
  const symbol = currencySymbols[preferredCurrency] || preferredCurrency + ' ';
  const rate = Number(exchangeData?.rates?.[preferredCurrency]);
  const timestamp = new Date(exchangeData?.providerUpdatedAt || exchangeData?.fetchedAt || 0).getTime();
  const fresh = timestamp > 0 && timestamp <= Date.now() + 300000 && Date.now() - timestamp <= 48 * 60 * 60 * 1000;

  // If USD or no exchange rate available, format original price to 2 decimals
  if (preferredCurrency === 'USD') {
    return `${symbol}${numericPrice.toFixed(2)}`;
  }

  if (!fresh || exchangeData?.base !== 'USD' || !Number.isFinite(rate) || rate <= 0) {
    return `USD ${numericPrice.toFixed(2)}`;
  }

  // Convert to preferred currency and include the symbol
  const convertedPrice = (numericPrice * exchangeData.rates[preferredCurrency]).toFixed(2);

  return `${symbol}${convertedPrice}`;
}
